// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TWM1y","page":"styles_page__Fn947","footer":"styles_footer__M5fgB","button":"styles_button__YHyvV"};